module.exports = __webpack_public_path__ + "static/media/back-nrfight.021a74ad.jpg";